:root {
  --White-Gradient: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 0.5) 60%,
    #ffffff 100%
  );
  --Grey-Gradient: linear-gradient(
    180deg,
    rgba(237, 241, 244, 0) 0%,
    rgba(237, 241, 244, 0.5) 60%,
    #edf1f4 100%
  );
  --Blue-Gradient: linear-gradient(
    180deg,
    rgba(0, 43, 73, 0) 0%,
    rgba(0, 43, 73, 0.5) 60%,
    #002b49 100%
  );
}

:host {
  display: block;
  position: relative;
}

.main-nav {
  width: 100%;
}
.main-nav.is-mobile {
  z-index: -1;
  position: fixed;
  top: var(--header-height);
  left: 0;
  right: 0;
  bottom: 0;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  visibility: hidden;
  translate: 0 -100%;
  interpolate-size: allow-keywords;
  transition: visibility 0.3s ease, translate 0.3s ease;
}
.main-nav.is-mobile.is-open {
  translate: 0 0;
  opacity: 1;
  visibility: visible;
}

.main-nav-content {
  border-top: 1px solid #edf1f4;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: calc(100% - var(--header-height));
  padding: 32px 24px 48px;
}
@media (max-width: 1199px) {
  .main-nav-content {
    overflow-y: scroll;
  }
}
@media (min-width: 1200px) {
  .main-nav-content {
    border-top: none;
    display: block;
    height: auto;
    padding: 0;
  }
}
.main-nav-content .main-nav-content-wrapper {
  padding-top: 56px;
  display: grid;
  row-gap: 12px;
}
.main-nav-content .main-nav-content-wrapper .overflow-nav-btn {
  display: none;
}
@media (min-width: 1200px) {
  .main-nav-content .main-nav-content-wrapper {
    padding: 0 32px;
    row-gap: unset;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    -moz-column-gap: 4px;
         column-gap: 4px;
  }
  .main-nav-content .main-nav-content-wrapper > dc-ui-button {
    display: none;
  }
  .main-nav-content .main-nav-content-wrapper.overflow {
    display: grid;
    grid-template-columns: auto auto auto;
  }
  .main-nav-content .main-nav-content-wrapper.overflow > dc-ui-button {
    display: block;
  }
  .main-nav-content .main-nav-content-wrapper .main-nav-content-wrapper-inner {
    padding: 0;
    row-gap: unset;
    display: flex;
    flex-direction: row;
    justify-content: center;
    -moz-column-gap: 4px;
         column-gap: 4px;
  }
  .main-nav-content .main-nav-content-wrapper .main-nav-content-wrapper-inner.overflow {
    overflow-x: auto;
    justify-content: flex-start;
    scrollbar-width: none;
    -ms-overflow-style: none;
  }
  .main-nav-content .main-nav-content-wrapper .main-nav-content-wrapper-inner.overflow::-webkit-scrollbar {
    display: none;
  }
}
@media (max-width: 1199px) {
  .main-nav-content .main-nav-content-wrapper .main-nav-content-wrapper-inner {
    display: grid;
    grid-template-columns: 1fr;
    gap: 12px;
  }
}
.main-nav-content .meta-nav-wrapper {
  display: grid;
  gap: 10px;
  padding-top: 32px;
  border-top: 1px solid #a3bac8;
}